import { gql } from '@apollo/client';

export const CREATE_COHORT = gql`
  mutation CreateCohort($input: UpsertCohortInput!) {
    cohort: createCohort(input: $input) {
      id
    }
  }
`;
